<template>
  <div>
    <!-- HEADING -->
    <section class="mb-5">
      <div class="container text-center">
        <div class="col-lg-10 mx-auto">
          <h2 class="font-size-medium font-weight-bold mb-4">{{ headerTitle }}</h2>
          <div class="mt-4 text-center">
            <router-link
              class="btn btn-outline-color2 btn-lg"
              :to="{ name: 'groups.create' }"
            >
              Criar nova
            </router-link>
          </div>
        </div>
      </div>
    </section> <!-- END HEADING -->

    <!-- FILTERS -->
    <section class="mb-5">
      <div class="container text-center d-flex flex-column flex-md-row justify-content-center align-items-center">
        <div class="paidSelect mr-md-3 mb-3 mb-md-0">
          <DropdownSelect
            v-model.trim="filters.paid"
            @change="reset"
            :options="paidOptions"
            size="xSmall"
          />
        </div>
        <div class="sortingSelect">
          <DropdownSelect
            v-model.trim="sort"
            @change="reset"
            :options="sortingOptions"
            size="xSmall"
          />
        </div>
      </div>
    </section> <!-- END FILTERS -->

    <!-- GROUPS -->
    <section>
      <div class="container">
        <div
          class="listing-rowed items-md-2-per-row mt-4"
          v-if="groups.length > 0"
        >
          <ul class="list-wrap">
            <li
              class="list-item"
              v-for="group in groups"
              :key="group.id"
            >
              <GroupCard
                :group="group"
                @group-destroyed="reset"
              />
            </li>
          </ul>
        </div>
        <div
          v-else-if="groups.length === 0 && !loader"
        >
          <p class="text-center">Nenhuma comunidade encontrada</p>
        </div>
        <Loader
          color="color2"
          size="big"
          v-else
        />

        <div
          class="mt-3 text-center"
          v-if="groups.length > 0 && isLoadMoreVisible"
        >
          <Button
            class="btn-outline-color2 btn-lg"
            :loading="loader"
            @click="loadMore"
          >
            Carregar mais
          </Button>
        </div>

      </div>
    </section> <!-- END GROUPS -->
  </div>
</template>

<script>

import variables from '@/mixins/variables'
import seo from '@/mixins/seo'
import { mapState } from 'vuex'
import GroupsService from '@/modules/groups/services/groups-service'

import GroupCard from '@/components/groups/GroupCard'
import Button from '@/components/common/Button/Button'
import Loader from '@/components/common/Loader/Loader'
import DropdownSelect from '@/components/common/Select/DropdownSelect'

export default {
  mixins: [variables, seo],
  components: {
    Button,
    GroupCard,
    Loader,
    DropdownSelect
  },
  data () {
    return {
      groups: [],
      loader: false,
      page: 1,
      isLoadMoreVisible: true,
      sort: 'relevance',
      filters: {
        paid: 'all'
      },
      sortingOptions: [
        {
          key: 'relevance',
          value: 'Maior relevância'
        },
        {
          key: 'ASC',
          value: 'Mais antigos'
        },
        {
          key: 'DESC',
          value: 'Mais recentes'
        },
        {
          key: 'members',
          value: 'Mais membros'
        }
      ],
      paidOptions: [
        {
          key: 'all',
          value: 'Comunidades pagas e gratuitas'
        },
        {
          key: 'paid',
          value: 'Comunidades pagas'
        },
        {
          key: 'free',
          value: 'Comunidades gratuitas'
        }
      ]
    }
  },
  metaInfo () {
    return {
      title: this.headerTitle,
      meta: [
        { vmid: 'og-title', name: 'og:title', content: this.headerTitle }
      ]
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    ...mapState('auth', {
      authenticated: state => state.authenticated
    }),
    isGeneralGroups () {
      return this.$route.name === 'groups.index'
    },
    headerTitle () {
      return this.isGeneralGroups ? 'Comunidades' : 'Minhas comunidades'
    }
  },
  watch: {
    user (newUser, oldUser) {
      if (!this.isGeneralGroups) this.getGroups()
    },
    $route (to, from) {
      this.reset()
    }
  },
  created () {
    this.getGroups()
  },
  methods: {
    async getGroups () {
      this.loader = true
      try {
        // Paid Group
        let isPaid = null
        if (this.filters.paid === 'paid') isPaid = true
        else if (this.filters.paid === 'free') isPaid = false

        // Get order by and sort
        let orderBy = null
        let sort = null

        switch (this.sort) {
          case 'ASC':
            orderBy = 'created_at'
            sort = 'ASC'
            break
          case 'DESC':
            orderBy = 'created_at'
            sort = 'DESC'
            break
          case 'members':
            orderBy = 'member_count'
            sort = 'DESC'
            break
          case 'relevance':
            orderBy = 'relevance'
            sort = 'ASC'
            break
        }

        let groups = []

        const params = {
          page: this.page,
          sort,
          orderBy,
          isPaid,
          itemsPerPage: 10
        }

        if (this.isGeneralGroups) groups = await GroupsService.getGroups(params)
        else {
          if (this.user) {
            groups = await GroupsService.getGroupsMemberships({ userId: this.user.id, page: this.page })
          }
        }
        this.setGroups(groups)
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.loader = false
    },
    setGroups (groups) {
      this.groups = [...this.groups, ...groups]
      if (groups.length <= 0) this.isLoadMoreVisible = false
    },
    loadMore () {
      this.page++
      this.getGroups()
    },
    reset () {
      this.loader = false
      this.groups = []
      this.page = 1
      this.isLoadMoreVisible = true
      this.getGroups()
    }
  }
}
</script>
